import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import ErrorBoundary from './ErrorBoundary'
import AppRoutes from './AppRoutes'
import Header from './components/header/Header'
import AsideMenu from './components/aside-menu/AsideMenu'
import { PATH } from './constants/path'
import Auth from './pages/auth/Auth'

import './App.css'
import AddCarModal from './components/modal/car-modal/AddCarModal'
import AddCompanyModal from './components/modal/company-modal/AddCompanyModal'
import { useSelector, useDispatch } from 'react-redux'
import { carsSelector } from './redux/selectors/cars-selector'
import { getCookie } from './utils/getCookies'
import { usersSelector } from './redux/selectors/users-selector'
import { store } from './redux/store'
import { AppDispatch } from './redux/store'
import {
  fetchDeleteUser,
  setIsVisibleDeleteModalUser,
} from './redux/reducers/users'
import {
  fetchDeleteCar,
  setIsVisibleDeleteModalCar,
} from './redux/reducers/cars'
import DeleteModal from './components/modal/DeleteModal'
import DeleteInvoiceModal from './components/modal/DeleteInvoiceModal'
import AddUserModal from './components/modal/user-modal/AddUserModal'
import {
  fetchDeleteCompany,
  setIsVisibleDeleteModalCompany,
} from './redux/reducers/company'

import { companySelector } from './redux/selectors/company-selector'
import ReportModal from './components/modal/report-modal/ReportModal'
import { reportsSelector } from './redux/selectors/reports-selector'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ChangeEmailModal from './components/modal/change-email-modal/ChangeEmailModal'
import { authSelector } from './redux/selectors/auth-selector'
import ResetPasswordModal from './pages/reset-password/ResetPassword'
import {
  fetchDeleteIncoming,
  fetchDeleteReport,
  setIsVisibleDeleteModalReport,
  setVisibleDeleteModalIncoming,
} from './redux/reducers/reports'
import NewServiceModal from './components/modal/new-service/NewServiceModal'
import { serviceSelector } from './redux/selectors/service-selector'
import { clientsSelector } from './redux/selectors/clients-selector'
import {
  fetchDeleteClient,
  setIsVisibleDeleteModalClient,
} from './redux/reducers/clients'
import { deletePart } from './redux/reducers/parts'
import AddClientModal from './components/modal/client-modal/AddClientModal'
import { contractsSelector } from './redux/selectors/documents/contracts-selector'
import AddContractsModal from './components/modal/documents/contracts/AddContractsModal'

import {
  fetchDeleteContract,
  setIsVisibleDeleteModalContract,
} from './redux/reducers/documents/contracts'
import LoadingPage from './components/loading/LoadingPage'
import { notesSelector } from './redux/selectors/notes-selector'
import { phonesSelector } from './redux/selectors/phones-selector'
import { partsSelector } from './redux/selectors/parts-selector'
import { notificationsSelector } from './redux/selectors/notification-selector'
import PartModal from './components/modal/part-modal/PartModal'
import { setIsVisibleDeleteModalPart } from './redux/reducers/parts'
import {
  deleteNotification,
  setVisibleDeleteModalNotification,
} from './redux/reducers/notifications'
import NotificationsModal from './components/modal/notifications-modal/NotificationsModal'
import WebPushSession from './components/web-push/WebPushSession'
import PdfViewer from './components/pdf-viewer/PdfViewer'
import {
  fetchDeleteNotes,
  setIsVisibleDeleteNote,
} from './redux/reducers/notes'
import {
  fetchDeleteServices,
  setIsVisibleDeleteService,
} from './redux/reducers/services'
import 'react-datetime/css/react-datetime.css'
import {
  fetchDeleteExpense,
  setVisibleDeleteModalExpenses,
} from './redux/reducers/reports'
import {
  fetchDeleteInvoice,
  fetchDetachCargo,
  fetchInvoices,
  setCurrentInvoice,
  setVisibleDeleteModalInvoice,
  setVisibleDetachCargosModal,
  setVisibleDeleteCargosModal,
  clearSelectedCargosForInvoice,
} from './redux/reducers/invoices'
import {
  fetchDeletePhones,
  setVisibleDeleteModalPhone,
} from './redux/reducers/phones'
import { reportsCommonSelector } from './redux/selectors/reports-common-selector'
import {
  fetchDeleteExpenseCommon,
  fetchDeleteReportCommon,
  setIsVisibleDeleteModalReportCommon,
  setVisibleDeleteModalExpensesCommon,
} from './redux/reducers/reports-common'
import CargoModal from './components/modal/cargo-modal/CargoModal'
import { cargosSelector } from './redux/selectors/cargos-selector'
import {
  fetchDeleteCargo,
  fetchCargos,
  setIsVisibleDeleteModalCargo,
  setIsVisibleDeleteManyModalCargo,
  fetchDeleteManyCargos,
  setSelectedCargosForDeletion,
  submitReportCargoDeleteFromDialog,
  setReportCargoDeleteDialog,
} from './redux/reducers/cargos'
import CargoSideModal from './components/modal/cargo-side-modal/CargoSideModal'
import InvoiceModal from './components/modal/invoice-modal/InvoiceModal'
import {
  invoicesSelector,
  isVisibleDetachCargosModalSelector,
  isVisibleDeleteCargosModalSelector,
} from './redux/selectors/invoices-selector'
import { getFiltersFromSessionStorage } from './utils/filterUtils'

const accessToken = getCookie('auth')

const App = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { isPendingContract } = useSelector(contractsSelector)
  const { isPendingAddCar } = useSelector(carsSelector)
  const { isPendingAddNote } = useSelector(notesSelector)
  const { isPendingAddService } = useSelector(serviceSelector)
  const { isPendingGetClient } = useSelector(clientsSelector)
  const { isPendingAddPhone } = useSelector(phonesSelector)
  const { isPendingAddUser } = useSelector(usersSelector)
  const { isPendingAddPart } = useSelector(partsSelector)

  const { isVisibleModalCar, isVisibleDeleteModalCar } =
    useSelector(carsSelector)
  const { isVisibleModalService } = useSelector(serviceSelector)
  const { isVisibleModalUser, isVisibleDeleteModalUser } =
    useSelector(usersSelector)
  const { isVisibleModalCompany, isVisibleDeleteModalCompany } =
    useSelector(companySelector)
  const { isVisibleModalChangeEmail } = useSelector(authSelector)
  const {
    isVisibleModalReport,
    isVisibleDeleteModalReport,
    isVisibleDeleteModalExpenses,
    isVisibleDeleteModalIncoming,
    isPendingAddExpense,
    isPendingDeleteExpense,
    isPendingGetCurrentReports,
    isPendingGetReports,
    isPendingReportCargosClientOrder,
  } = useSelector(reportsSelector)

  const {
    isVisibleModalReportCommon,
    isPendingGetCurrentReportsCommon,
    isVisibleDeleteModalReportCommon,
    isVisibleDeleteModalExpensesCommon,
    isPendingGetReportsCommon,
    isPendingAddExpenseCommon,
  } = useSelector(reportsCommonSelector)
  const { isVisibleModalClient, isVisibleDeleteModalClient } =
    useSelector(clientsSelector)
  const { isVisibleDeleteModalContract, isVisibleModalContract } =
    useSelector(contractsSelector)
  const { isVisibleModalPart, isVisibleDeleteModalPart } =
    useSelector(partsSelector)
  const { isVisibleNotifications, isVisibleDeleteModalNotification } =
    useSelector(notificationsSelector)

  const {
    isVisibleModalCargo,
    isVisibleDeleteModalCargo,
    isVisibleDeleteManyModalCargo,
    isPendingGetCargos,
    isPendingAddCargos,
    isPendingDeleteManyCargos,
    reportCargoDeleteDialog,
  } = useSelector(cargosSelector)

  const {
    isVisibleModalInvoice,
    isVisibleDeleteModalInvoice,
    isPendingGetInvoices,
    showDeleteInvoiceChoice,
    currentInvoice,
  } = useSelector(invoicesSelector)

  const isVisibleDetachCargosModal = useSelector(
    isVisibleDetachCargosModalSelector
  )
  const isVisibleDeleteCargosModal = useSelector(
    isVisibleDeleteCargosModalSelector
  )

  const isVisibleLoadingPage =
    isPendingContract ||
    isPendingAddCar ||
    isPendingAddNote ||
    isPendingAddService ||
    isPendingGetClient ||
    isPendingAddPhone ||
    isPendingAddUser ||
    isPendingAddPart ||
    isPendingAddExpense ||
    isPendingAddExpenseCommon ||
    isPendingDeleteExpense ||
    isPendingGetCurrentReports ||
    isPendingGetReports ||
    isPendingGetCurrentReportsCommon ||
    isPendingGetReportsCommon ||
    isPendingGetCargos ||
    isPendingGetInvoices ||
    isPendingAddCargos ||
    isPendingDeleteManyCargos ||
    isPendingReportCargosClientOrder

  const { isVisibleDeleteModalPhone } = useSelector(phonesSelector)

  const { isVisibleDeleteNote } = useSelector(notesSelector)
  const { isVisibleDeleteService } = useSelector(serviceSelector)

  return (
    <ErrorBoundary>
      <PdfViewer />
      <Router>
        <Switch>
          {!getCookie('auth') && (
            <Route exact path={PATH.AUTH} component={Auth} />
          )}
          <Route
            exact
            path={PATH.RESET_PASSWORD}
            component={ResetPasswordModal}
          />
          <Route
            render={() =>
              getCookie('auth') ? (
                <div className="container-header">
                  <AsideMenu />
                  <div className="container-main">
                    <Header />
                    <WebPushSession />
                    <AppRoutes />
                  </div>
                </div>
              ) : (
                <Redirect to={PATH.AUTH} />
              )
            }
          />
        </Switch>
      </Router>
      {Boolean(accessToken) && (
        <>
          {isVisibleModalService && <NewServiceModal />}
          {isVisibleModalCar && <AddCarModal />}
          {isVisibleModalUser && <AddUserModal />}
          {isVisibleModalCompany && <AddCompanyModal />}
          {isVisibleModalChangeEmail && <ChangeEmailModal />}
          {isVisibleModalClient && <AddClientModal />}
          {isVisibleModalReport && <ReportModal />}
          {isVisibleModalReportCommon && <ReportModal />}
          {isVisibleModalContract && <AddContractsModal />}
          {isVisibleModalPart && <PartModal />}
          {isVisibleNotifications && <NotificationsModal />}
          {isVisibleModalCargo && <CargoModal />}

          <CargoSideModal />
          {isVisibleModalInvoice && <InvoiceModal />}

          {isVisibleDeleteModalCar && (
            <DeleteModal
              title="Транспорт"
              onConfirm={fetchDeleteCar()}
              onCancel={setIsVisibleDeleteModalCar(false)}
            />
          )}
          {isVisibleDeleteModalUser && (
            <DeleteModal
              title="Водитель"
              onConfirm={fetchDeleteUser()}
              onCancel={setIsVisibleDeleteModalUser(false)}
            />
          )}
          {isVisibleDeleteModalCompany && (
            <DeleteModal
              title="Company"
              onConfirm={fetchDeleteCompany()}
              onCancel={setIsVisibleDeleteModalCompany(false)}
            />
          )}

          {isVisibleDeleteModalReport && (
            <DeleteModal
              title="Путевой"
              onConfirm={fetchDeleteReport()}
              onCancel={setIsVisibleDeleteModalReport(false)}
            />
          )}

          {isVisibleDeleteModalReportCommon && (
            <DeleteModal
              title="Путевой"
              onConfirm={fetchDeleteReportCommon()}
              onCancel={setIsVisibleDeleteModalReportCommon(false)}
            />
          )}
          {isVisibleDeleteModalClient && (
            <DeleteModal
              title="Клиента"
              onConfirm={fetchDeleteClient()}
              onCancel={setIsVisibleDeleteModalClient(false)}
            />
          )}
          {isVisibleDeleteModalContract && (
            <DeleteModal
              title="Контракт"
              onConfirm={fetchDeleteContract()}
              onCancel={setIsVisibleDeleteModalContract(false)}
            />
          )}
          {isVisibleDeleteModalPart && (
            <DeleteModal
              title="Запчасть"
              onConfirm={deletePart()}
              onCancel={setIsVisibleDeleteModalPart(false)}
            />
          )}
          {isVisibleDeleteModalNotification && (
            <DeleteModal
              title="Уведомление"
              onConfirm={deleteNotification()}
              onCancel={setVisibleDeleteModalNotification(false)}
            />
          )}
          {isVisibleDeleteModalPhone && (
            <DeleteModal
              title="Телефон"
              onConfirm={fetchDeletePhones()}
              onCancel={setVisibleDeleteModalPhone(false)}
            />
          )}
          {isVisibleDeleteModalExpenses && (
            <DeleteModal
              title="Расходы"
              onConfirm={fetchDeleteExpense()}
              onCancel={setVisibleDeleteModalExpenses(false)}
            />
          )}
          {isVisibleDeleteModalExpensesCommon && (
            <DeleteModal
              title="Расходы"
              onConfirm={fetchDeleteExpenseCommon()}
              onCancel={setVisibleDeleteModalExpensesCommon(false)}
            />
          )}
          {isVisibleDeleteModalIncoming && (
            <DeleteModal
              title="Приходы"
              onConfirm={fetchDeleteIncoming()}
              onCancel={setVisibleDeleteModalIncoming(false)}
            />
          )}
          {isVisibleDeleteNote && (
            <DeleteModal
              title="Заметку"
              onConfirm={fetchDeleteNotes()}
              onCancel={setIsVisibleDeleteNote(false)}
            />
          )}

          {isVisibleDeleteService && (
            <DeleteModal
              title="Сервис"
              onConfirm={fetchDeleteServices()}
              onCancel={setIsVisibleDeleteService(false)}
            />
          )}

          {isVisibleDeleteModalCargo && (
            <DeleteModal
              title="Груз"
              onConfirm={fetchDeleteCargo()}
              onCancel={setIsVisibleDeleteModalCargo(false)}
            />
          )}

          {reportCargoDeleteDialog && (
            <DeleteModal
              heading={
                reportCargoDeleteDialog.type === 'delivery'
                  ? 'Действительно удалить данную доставку?'
                  : undefined
              }
              title={
                reportCargoDeleteDialog.type === 'shipment' ? 'груз' : undefined
              }
              onConfirm={submitReportCargoDeleteFromDialog()}
              onCancel={setReportCargoDeleteDialog(null)}
            />
          )}

          {isVisibleDeleteManyModalCargo && (
            <DeleteModal
              title="выбранные доставки"
              onConfirm={() => {
                // Получаем выбранные грузы из Redux и выполняем удаление
                const state = store.getState()
                const selectedCargos = state.cargos.selectedCargosForDeletion
                if (selectedCargos.length > 0) {
                  dispatch(fetchDeleteManyCargos(selectedCargos))
                  dispatch(setSelectedCargosForDeletion([]))
                }
                dispatch(setIsVisibleDeleteManyModalCargo(false))
              }}
              onCancel={setIsVisibleDeleteManyModalCargo(false)}
            />
          )}

          {isVisibleDetachCargosModal && (
            <DeleteModal
              title={`(открепить) выбранные грузы от счёта`}
              onConfirm={() => {
                // Получаем выбранные грузы из Redux и выполняем открепление
                const state = store.getState()
                const selectedCargos = state.invoices.selectedCargosForInvoice
                if (selectedCargos.length > 0 && currentInvoice) {
                  dispatch(
                    fetchDetachCargo({
                      invoiceId: String(currentInvoice.id),
                      selectedCargos: selectedCargos,
                    })
                  ).then((res) => {
                    //@ts-ignore
                    if (!res.error) {
                      dispatch(fetchCargos())
                      // Обновляем текущий счёт
                      if (currentInvoice) {
                        const updatedInvoice = {
                          ...currentInvoice,
                          cargos: currentInvoice.cargos.filter(
                            (cargo) => !selectedCargos.includes(cargo.id)
                          ),
                          sum:
                            currentInvoice.sum -
                            selectedCargos.reduce((sum, id) => {
                              const cargo = currentInvoice.cargos.find(
                                (c) => c.id === id
                              )
                              return sum + (cargo?.amount || 0)
                            }, 0),
                        }
                        dispatch(setCurrentInvoice(updatedInvoice))

                        // Также обновляем список всех счетов
                        const filters = getFiltersFromSessionStorage()

                        if (filters) {
                          dispatch(fetchInvoices(filters))
                        }

                        // Очищаем выбранные грузы
                        dispatch(clearSelectedCargosForInvoice())
                      }
                    }
                  })
                }
                dispatch(setVisibleDetachCargosModal(false))
              }}
              onCancel={() => dispatch(setVisibleDetachCargosModal(false))}
            />
          )}

          {isVisibleDeleteCargosModal && (
            <DeleteModal
              title={`выбранные грузы из счёта`}
              onConfirm={() => {
                const state = store.getState()
                const selectedCargos = state.invoices.selectedCargosForInvoice
                if (selectedCargos.length > 0) {
                  dispatch(fetchDeleteManyCargos(selectedCargos)).then(
                    (res) => {
                      //@ts-ignore
                      if (!res.error) {
                        dispatch(fetchCargos())
                        // Обновляем текущий счёт, убирая удалённые грузы
                        if (currentInvoice) {
                          const updatedInvoice = {
                            ...currentInvoice,
                            cargos: currentInvoice.cargos.filter(
                              (cargo) => !selectedCargos.includes(cargo.id)
                            ),
                            sum:
                              currentInvoice.sum -
                              selectedCargos.reduce((sum, id) => {
                                const cargo = currentInvoice.cargos.find(
                                  (c) => c.id === id
                                )
                                return sum + (cargo?.amount || 0)
                              }, 0),
                          }
                          dispatch(setCurrentInvoice(updatedInvoice))

                          // Также обновляем список всех счетов
                          const filters = getFiltersFromSessionStorage()
                          if (filters) {
                            dispatch(fetchInvoices(filters))
                          }

                          // Очищаем выбранные грузы
                          dispatch(clearSelectedCargosForInvoice())
                        }
                      }
                    }
                  )
                }
                dispatch(setVisibleDeleteCargosModal(false))
              }}
              onCancel={() => dispatch(setVisibleDeleteCargosModal(false))}
            />
          )}

          {isVisibleDeleteModalInvoice && (
            <>
              {/* Показываем модалку с выбором действия, если есть грузы */}
              {showDeleteInvoiceChoice && (
                <DeleteInvoiceModal
                  onConfirm={(action) => {
                    dispatch(fetchDeleteInvoice(action))
                  }}
                  onCancel={() => {
                    dispatch(setVisibleDeleteModalInvoice(false))
                  }}
                />
              )}

              {/* Показываем простую модалку удаления, если грузов нет */}
              {!showDeleteInvoiceChoice && (
                <DeleteModal
                  title="Счёт"
                  onConfirm={() => {
                    dispatch(fetchDeleteInvoice('delete'))
                  }}
                  onCancel={() => {
                    dispatch(setVisibleDeleteModalInvoice(false))
                  }}
                />
              )}
            </>
          )}
          {isVisibleLoadingPage && <LoadingPage />}
        </>
      )}
      <ToastContainer
        autoClose={1500}
        style={{ zIndex: 1000000000 }}
        position="top-center"
      />
    </ErrorBoundary>
  )
}

export default App
